import React from 'react'
import { Empty, Button } from '@douyinfe/semi-ui'
import {useNavigate } from 'react-router-dom'
import { IllustrationNoAccess, IllustrationConstruction } from '@douyinfe/semi-illustrations'

const Result  = ({ title, description, type, location }) => {
	const navigate = useNavigate()


	console.log('type', type)
	return (
		<Empty
			image={
				type == '403' ? (
					<IllustrationNoAccess style={{ width: 150, height: 150 }} />
				) : (
					<IllustrationConstruction style={{ width: 150, height: 150 }} />
				)
			}
			title={title}
			description={description}
			style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
		>
			<Button
				style={{ padding: '6px 24px', width: ' 180px' }}
				theme="solid"
				type="primary"
				onClick={
					type === '403'
						? () => navigate(`/login${'?from=' + encodeURIComponent(location.pathname)}`, { replace: true })
						: () => window.history.back()
				}
			>
				{type === '403' ? '去登录' : '回到首页'}
			</Button>
		</Empty>
	)
}

export default Result
